$(document).ready(function(){
  
  			if($('h1').length>1)
            {
  			let i=1,str;
  			$('h1').each(function(){
  			if(i>1)
    			{
  			str=$(this).text();
        			$(this).replaceWith(`<h2>${str}</h2>`);
    			}
    			i++;        
			});
            }
 			
  
  $(document).on('click','.logo-tabs-inner',function(){
    $('.logo-tabs-inner').removeClass('active-tab');
    $(this).addClass('active-tab');
    $('.logo-tabs-logo-wraper').hide();
    var show_class = $(this).data('val');
    $('.'+show_class).show();
    $('.logo-tabs-logo-wraper').slick('setPosition');
  });

  });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}